import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface IntellectRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard component that only renders children if ?intellect=on is in the URL query parameters.
 * If the parameter is not present, redirects to the home page.
 * This follows the same pattern as LabsRoute for feature toggle functionality.
 */
const IntellectRoute: React.FC<IntellectRouteProps> = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isIntellectEnabled = searchParams.get('intellect') === 'on';

  if (!isIntellectEnabled) {
    // Redirect to home page if intellect is not enabled
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default IntellectRoute;
